<div class="mb-2 flex items-center justify-between">
  <h1 class="main-title">{{ pageTitle }}</h1>
  <div>
    <ng-container *ngIf="!shiftClosureId; else myNewsButton">
      <button class="button button-outlined-primary button-sm mr-3" (click)="goToPreviousShift()">
        Novedades Turno Anterior
      </button>
    </ng-container>
    <ng-template #myNewsButton>
      <button class="button button-outlined-primary button-sm mr-3" (click)="goToMyNews()">
        Mis Novedades
      </button>
    </ng-template>
    <button
      *ngIf="!isPreviousView"
      class="button button-outlined-primary button-sm mr-3"
      (click)="openPdfPreview()"
    >
      Previsualización
    </button>

    <button *ngIf="!isPreviousView" class="button button-warning button-sm" (click)="shiftClosure()">
      Generar informe de turno
    </button>
  </div>
</div>

<div class="box mb-4" *ngIf="showGeneralNewsSection">
  <h2 class="main-subtitle">Novedades del turno</h2>
  
  <h3>Seguridad / Calidad / Medio Ambiente</h3>
  <app-table
    class="table-news table-switch"
    [columns]="isPreviousView ? shiftUpdatesTableColumnsRO : shiftUpdatesTableColumns"
    [data]="seguridadCalidadMedioAmbiente"
    [tableType]="'seguridad_calidad'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!isPreviousView" (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!isPreviousView && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Personal</h3>
  <app-table
    class="table-news table-switch"
    [columns]="isPreviousView ? shiftUpdatesTableColumnsRO : shiftUpdatesTableColumns"
    [data]="personalData" 
    [tableType]="'personal'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!isPreviousView" (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!isPreviousView && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<div class="box pb-16">
  <h2 class="main-subtitle mb-3">Novedades por área</h2>

  <h3>Proceso General</h3>
  <app-table
    class="table-news table-switch"
    [columns]="isPreviousView ? generalTableColumnsRO : generalTableColumns"
    [data]="flattenedData['novedades']"
    [tableType]="'novedades'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <!--
        <ng-container *ngIf="shiftClosureId">
          <button (click)="openCloneConfirmation(visation)" title="Clonar">
            <img src="assets/icons/copy-icon.svg" alt="" />
          </button>
        </ng-container>
        -->
        <ng-container *ngIf="!shiftClosureId && !isPreviousView">
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
        </ng-container>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Aviso de averías solicitado</h3>
  <app-table
    class="table-news table-switch"
    [columns]="isPreviousView ? reportedBreakdownNoticeTableColumnsRO : reportedBreakdownNoticeTableColumns"
    [data]="flattenedData['aviso_averias']"
    [tableType]="'aviso_averias'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <!-- 
        <ng-container *ngIf="shiftClosureId">
          <button (click)="openCloneConfirmation(visation)" title="Clonar">
            <img src="assets/icons/copy-icon.svg" alt="" />
          </button>
        </ng-container>
        -->
  <ng-container *ngIf="!shiftClosureId && !isPreviousView">
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <!-- 
          <button
            (click)="deleteUpdateRecord(visation.id)"
            title="Eliminar"
          >
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
          -->
        </ng-container>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Orden de Trabajo</h3>
  <div style="width: 100%; overflow: auto">
    <app-table
      class="table-news table-switch"
      [columns]="isPreviousView ? workOrderTableColumnsRO : workOrderTableColumns"
      [data]="flattenedData['o_t_ejecutadas']"
      [tableType]="'o_t_ejecutadas'"
      (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
      (selectAllChange)="onSelectAllChange($event)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)" title="Ver">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <!-- 
          <ng-container *ngIf="shiftClosureId">
            <button (click)="openCloneConfirmation(visation)" title="Clonar">
              <img src="assets/icons/copy-icon.svg" alt="" />
            </button>
          </ng-container>
        -->
          <ng-container *ngIf="!shiftClosureId && !isPreviousView">
            <button (click)="editUpdateRecord(visation)" title="Editar">
              <img src="assets/icons/pencil-icon.svg" alt="" />
            </button>
            <!-- 
            <button
              (click)="deleteUpdateRecord(visation.id)"
              title="Eliminar"
            >
              <img src="assets/icons/trashcan-icon.svg" alt="" />
            </button>
            -->
          </ng-container>
        </div>
      </ng-template>
    </app-table>
  </div>

  <h3 class="mt-10">Fuera de servicios</h3>
  <app-table
    class="table-news table-switch"
    [columns]="isPreviousView ? outOfServiceTableColumnsRO : outOfServiceTableColumns"
    [data]="flattenedData['fuera_servicio']"
    [tableType]="'fuera_servicio'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <!-- 
        <ng-container *ngIf="shiftClosureId">
          <button (click)="openCloneConfirmation(visation)" title="Clonar">
            <img src="assets/icons/copy-icon.svg" alt="" />
          </button>
        </ng-container>
        -->
  <ng-container *ngIf="!shiftClosureId && !isPreviousView">
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <!-- 
          <button
            (click)="deleteUpdateRecord(visation.id)"
            title="Eliminar"
          >
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
          -->
        </ng-container>
      </div>
    </ng-template>
  </app-table>
</div>

<app-confirm-popup
  *ngIf="showConfirmPopup"
  [message]="'¿Estás seguro que deseas iniciar un nuevo turno?'"
  (onConfirm)="confirmStartShift()"
  (onCancel)="closeConfirmPopup()"
></app-confirm-popup>

<app-confirm-popup
  *ngIf="showClonePopup"
  [message]="'¿Está seguro que deseas copiar esta novedad?'"
  (onConfirm)="confirmClone()"
  (onCancel)="closeClonePopup()"
></app-confirm-popup>
